import "@pistonite/intwc/monaco/styles";
import "@pistonite/intwc/monaco/language-cpp";
const typescript = undefined;
const json = undefined;
const css = undefined;
const html = undefined;

export function vLoadMonacoGlobals(getGlobalMonaco) {
const monacoApi = getGlobalMonaco();
monacoApi.languages.css = css;
monacoApi.languages.html = html;
monacoApi.languages.typescript = typescript;
monacoApi.languages.json = json;
return { css, html, typescript, json };
}
